import {
  esk900FnCommonNav,
  esk900MediaKeys,
  fnFRowStandard,
  type FactoryKeyMap,
  type KeysConfig,
} from './common'

const factoryKeysWin: FactoryKeyMap = {
  ...fnFRowStandard,
  ...esk900FnCommonNav,
  '?_/': 'LED_Color',
}

export const esk90083Keys: KeysConfig = {
  factoryKeys: {
    win: factoryKeysWin,
    mac: { ...factoryKeysWin },
  },
  mediaKeys: [...esk900MediaKeys],
}
